import { Component, OnInit } from '@angular/core';

import { MedioService } from './medio.service';
import { SpinnerModule } from 'src/app/plasma-ui-common/synlab-access-ui-components/spinner/spinner.component';

@Component({
  selector: 'app-medio-redirect',
  imports: [SpinnerModule],
  templateUrl: './medio-redirect.component.html',
  styleUrls: ['./medio-redirect.component.scss'],
})
export class MedioRedirectComponent implements OnInit {
  constructor(private readonly medio: MedioService) {}

  ngOnInit(): void {
    this.medio.redirect();
  }
}
